import type { AirHostSettings } from "@/lib/gql/__generated__/graphql";

import type { AutoGeneratorForFormModel } from "@/components/features/_model";

import type { SiteControllerSettingBaseInputZodSchemaType } from "./validation-schema";

const _excludeKeys = ["hotelID"] as const;
export const excludeKeys = _excludeKeys.map((key) => key);
export type ExcludeKeys = (typeof excludeKeys)[number];

type QueryData = {
	roomKVList: { name: string; roomID: string }[];
	airHostSettingsBaseInfo: Pick<
		AirHostSettings,
		"airHostPartnerID" | "airHostAPIAccessToken" | "airHostPropertyID" | "chillnnRoomAndAirHostPricePlanMappings"
	>;
	isSiteControllerRegistered: boolean;
};

export type SiteControllerSettingBaseFormModel = AutoGeneratorForFormModel<
	SiteControllerSettingBaseInputZodSchemaType,
	ExcludeKeys,
	QueryData
>;
